import React from 'react';

import { IPetsyFeatureLabelGroupProps } from './PetsyFeatureLabelGroup.types';

import './PetsyFeatureLabelGroup.scss';
import FeatureLabel from '../FeatureLabel';
import { FlowTypes, IconColorStyle } from '@adaptis/flow-components';
import { IFeatureLabelProps } from '../FeatureLabel/FeatureLabel.types';

export default function PetsyFeatureLabelGroup(
  props: IPetsyFeatureLabelGroupProps
) {
  const [featureLabels, setFeatureLabels] = React.useState<
    Array<IFeatureLabelProps>
  >([]);

  React.useEffect(() => {
    setFeatureLabels(getPetsyFeatureGroupSettings());
  }, []);

  function getPetsyFeatureGroupSettings() {
    let petsyFeatureLabels = props?.helperText?.petsyFeatureLabels;

    if (!petsyFeatureLabels) return [];

    return petsyFeatureLabels as Array<IFeatureLabelProps>;
  }

  return (
    <div
      data-testid='PetsyFeatureLabelGroup'
      className={
        'flc_petsy-feature-label-group ' +
        (props.className ? props?.className : '')
      }>
      {featureLabels &&
        featureLabels.map(
          (featureLabel: IFeatureLabelProps, index: number): JSX.Element => {
            return (
              <FeatureLabel
                key={index}
                iconColorStyle={IconColorStyle.Plain}
                label={featureLabel.label}
                image='/images/icons/check-green-bg.svg'
              />
            );
          }
        )}
    </div>
  );
}
